import 'slick-carousel'
import '@fancyapps/fancybox';

export default {
	init() {
		$('.carousel').slick({
			adaptiveHeight: true,
			dots: false,
			arrows: false,
			fade: true,
		})


    $().fancybox({
      selector : '[data-fancybox]',
    });

		$('.slick-next').click(function(){
			$('.carousel').slick('slickNext');
		})

		$('.slick-prev').click(function(){
			$('.carousel').slick('slickPrev');
		})

		$(document).on('keydown', function(e) {
			if(e.keyCode == 37) {
				$('.carousel').slick('slickPrev');
			}
			if(e.keyCode == 39) {
				$('.carousel').slick('slickNext');
			}
		});
	},
	finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js